export interface ClassicReportItem {
  id: string;
  title: string;
  type: string;
  description: string;
  path: string;
}

export const CLASSIC_REPORTS: ClassicReportItem[] = [
  {
    id: '1',
    title: 'Closed Invoices',
    type: 'Invoice',
    description: 'My invoice grid description...',
    path: 'closed-invoices'
  },
  {
    id: '2',
    title: 'My Tasks',
    type: 'Task',
    description: 'My Task grid description...',
    path: 'my-tasks'
  },
  {
    id: '3',
    title: 'Invoice Open Sales Rep',
    type: 'Invoice',
    description: 'Invoice Open Sales Rep grid description...',
    path: 'invoice-open-sales-rep'
  },
  {
    id: '4',
    title: 'Paid & Left Review',
    type: 'Job',
    description: 'My Job grid description...',
    path: 'paid-and-left-review'
  },
  {
    id: '5',
    title: 'Payments',
    type: 'Payment',
    description: 'My payments grid description...',
    path: 'payments'
  },
  {
    id: '6',
    title: 'My Payments',
    type: 'Payment',
    description: 'My Payments grid description...',
    path: 'my-payments'
  },
  {
    id: '7',
    title: 'Invoice Open',
    type: 'Invoice',
    description: 'Invoice Open grid description...',
    path: 'invoice-opens'
  },
  {
    id: '8',
    title: 'Invoice Listing',
    type: 'Invoice',
    description: 'Invoice Listing grid description...',
    path: 'invoice-listings'
  },
  {
    id: '9',
    title: 'Jobs In Progress & Completed',
    type: 'Job',
    description: 'Jobs In Progress & Completed grid description...',
    path: 'jobs-in-progress-completeds'
  },
  // {
  //   id: '4',
  //   title: 'Estimate vs. Actuals',
  //   type: 'Estimate',
  //   description: 'Estimate vs. Actuals grid description...',
  //   path: 'estimate-vs-actuals'
  // }
  {
    id: '7',
    title: 'Roofs',
    type: 'Job',
    description: 'My Job grid description...',
    path: 'roofs'
  },
  {
    id: '8',
    title: 'Shelbyville Job',
    type: 'Job',
    description: 'My Job grid description...',
    path: 'shelbyville-job'
  },
  {
    id: '9',
    title: 'Shingle Color',
    type: 'Job',
    description: 'My Job grid description...',
    path: 'shingle-color'
  },
  {
    id: '10',
    title: 'Shingle',
    type: 'Job',
    description: 'My Job grid description...',
    path: 'shingle'
  }
];
